import { personName } from 'Data/format.js'

export function getResources(booking) {
  return [
    booking.provider?.employment_contract?.person,
    booking.assistant?.employment_contract?.person,
  ]
    .filter(Boolean)
    .map(item => personName(item))
    .join(' - ')
}
